import axios from 'axios'
import router from '@/router'
import { clearLoginInfo } from '@/utils/common'
import srmconfig from '@/utils/pc'
const CancelToken = axios.CancelToken;
const source = CancelToken.source();

const statusCode = {
    400: '请求格式不正确，操作失败',
    401: '登录超时，请重新登录',
    403: '拒绝访问',
    404: '未找到相应网络资源，无法访问',
    405: '请求方法不支持',
    408: '请求超时，请稍后重试',
    500: '服务器内部错误，请联系管理员',
    501: '服务未实现',
    502: '网关错误，请联系管理员',
    503: '服务不可用',
    504: '网关超时',
    505: 'HTTP版本不受支持'
}

let clientType = 'ct:' + srmconfig['ct']

const http = axios.create({
    baseURL: process.env.NODE_ENV === 'production' ? '/test' : '/dev',
    timeout: 1000 * 60, //60秒
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json; charset=utf-8'
    },
    validateStatus: function (status) {
        if (status !== 200) {
            router.app.$message({type: 'error', message: statusCode[status.toString()]})
        }
        return status;
    }
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
    // config.headers['Authorization'] = sessionStorage.getItem('token')
    config.headers['token'] = sessionStorage.getItem('token')
    config.headers['source_id'] = 'FE' + clientType
    config.cancelToken = source.token
    return config
}, error => {
    return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {
    if (response.data.status && response.data.status !== 200) {
        return Promise.reject(response.data.status)
    }
    if (response.data.code === '02') { // token失效
        clearLoginInfo()
        router.replace({name: 'login'})
        // router.app.$message({type: 'error', message: '登录验证无效或过期，请重新登录。'})
        // source.cancel();
    }
    return response.data
}, error => {
    if (axios.isCancel(error)) { // 取消请求的情况下，终止Promise调用链
        return new Promise(() => {});
    } else {
        return Promise.reject(error);
    }
})

function getAppendParams() {
    let params = {}
    if(sessionStorage.getItem('tenantId')){
        params['tenantId'] = sessionStorage.getItem('tenantId')
    }
    if(sessionStorage.getItem('mainBodyId')){
        params['mainBodyId'] = sessionStorage.getItem('mainBodyId')
    }
    return params
}

export default http

/**
 * get 请求方法
 * @param url
 * @param params
 * @returns {Promise}
 */
export function get(url, params = {}, pathParam) {
    params = {...getAppendParams(), ...params}
    return new Promise((resolve, reject) => {
        http.get(pathParam == null ? url : url + '/' + pathParam, {
            params: params
        })
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * post 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data = {}) {
    if(!data.length){
        data = {...getAppendParams(), ...data}
    }
    return new Promise((resolve, reject) => {
        http.post(url, data).then(
            response => {
                // console.log(response.data.code)
                resolve(response)
            },
            err => {
                reject(err)
            }
        )
    })
}
/**
 * 专用于下载 ZIP / 二进制文件的 POST 请求
 * 使用原生 axios（不经过你封装的 http 实例，因此不走拦截器）
 * 但手动配置 baseURL、timeout、withCredentials、headers 等，与你的 http 实例保持一致
 * @param url 请求地址
 * @param data 请求参数
 * @param config 额外的 axios 配置，比如 { responseType: 'arraybuffer' }
 * @returns {Promise<any>} 返回完整的 axios 响应对象
 */
export function postZip(url, data = {}, config = {}) {
    // 环境相关的 baseURL，和你项目中的 http 实例保持一致
    const baseURL = process.env.NODE_ENV === 'production' ? '/test' : '/dev';

    // 合并用户传入的 config 和默认配置
    const finalConfig = {
        baseURL, // 动态设置 baseURL
        timeout: 1000 * 60, // 60秒超时
        withCredentials: true, // 携带 cookie
        headers: {
            'Content-Type': 'application/json; charset=utf-8', // 默认请求头
            ...(config.headers || {}), // 允许调用方覆盖 headers
        },
        ...config, // 用户传入的其它配置，比如 responseType: 'arraybuffer'
    };

    // 使用原生 axios 发请求
    return new Promise((resolve, reject) => {
        axios.post(url, data, finalConfig)
            .then(response => {
                resolve(response); // 返回完整响应对象，包含 response.data（如 ArrayBuffer）
            })
            .catch(err => {
                reject(err);
            });
    });
}

/**
 * post 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function importData(url, data = {}) {

    return new Promise((resolve, reject) => {
        http.post(url, data).then(
            response => {
                // console.log(response.data.code)
                resolve(response)
            },
            err => {
                reject(err)
            }
        )
    })
}

export function upload(url, data) {
    return new Promise((resolve, reject) => {
        http.post(url, data, {
            headers: {
                'Content-type': 'multipart/form-data;boundary = ' + new Date().getTime()
            }
        }).then(
            response => {
                // console.log(response.data.code)
                resolve(response)
            },
            err => {
                reject(err)
            }
        )
    })
}

/**
 * 专用于下载二进制文件的 GET 请求（带 token，返回 Blob）
 * 走封装实例以复用 token 拦截器；responseType=blob 使响应不被 JSON 解析
 * @param url
 * @param params
 * @returns {Promise}
 */
export function getBlob(url, params = {}) {
    params = {...getAppendParams(), ...params}
    return new Promise((resolve, reject) => {
        http.get(url, { params: params, responseType: 'blob' })
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    })
}

